import React from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ColorBodyCopyNPM from '@rotaryintl/component-color-body-copy';
import { createLink } from '../../utilities/link-helpers';

const ColorBodyCopy = ({ params: { ComponentId } = {}, fields: { Title, Subtitle, Text: TextField, BackgroundColor, Link, LinkText } = {} }) => {
  const hasLink = Link?.value?.href && LinkText?.value;
  return (
    <ColorBodyCopyNPM
      id={ComponentId}
      title={<Text field={Title} />}
      subtitle={<Text field={Subtitle} />}
      text={<RichText field={TextField} />}
      backgroundColor={BackgroundColor?.fields?.Color?.value ?? 'darkBlue'}
      link={hasLink ? createLink(Link, LinkText) : null}
    />
  );
};

export default withSitecoreContext()(ColorBodyCopy);